/**
 * Spiegel von src/StayOn.Core/Search/QuickSearchContracts.cs. Suchbegriffe sind PII →
 * werden als POST-Body übertragen (nie Query-String). Kind-Union = SearchHitKinds.cs.
 */
import type { PagedResult } from './shared';

export type SearchHitKind =
  | 'property-group'
  | 'apartment'
  | 'booking'
  | 'guest'
  | 'parking'
  | 'finance';

export interface QuickSearchRequest {
  query: string;
  /** Navbar-Scope; serverseitig mit AllowedPropertyIds geschnitten. null = alle erlaubten. */
  propertyIds?: string[] | null;
  limit?: number;
}

export interface QuickSearchHit {
  kind: SearchHitKind;
  id: string;
  title: string;
  subtitle?: string | null;
  propertyId?: string | null;
  score: number;
}

export interface QuickSearchResponse {
  hits: QuickSearchHit[];
  truncated: boolean;
}

/* Advanced-Search-DSL — Spiegel von src/StayOn.Core/Search/*. Enums als PascalCase-Strings
 * (Backend JsonStringEnumConverter). SchemaVersion muss zum Katalog passen. */

export const SEARCH_SCHEMA_VERSION = 1;

export type SearchFieldType =
  | 'Text'
  | 'Number'
  | 'Money'
  | 'Date'
  | 'DateTime'
  | 'Boolean'
  | 'Enum'
  | 'Id';

export type SearchOperator =
  | 'Equals'
  | 'NotEquals'
  | 'Contains'
  | 'StartsWith'
  | 'In'
  | 'LessThan'
  | 'LessThanOrEqual'
  | 'GreaterThan'
  | 'GreaterThanOrEqual'
  | 'Between'
  | 'IsEmpty'
  | 'IsNotEmpty';

export type SearchGroupLogic = 'And' | 'Or';

export interface SearchFieldDto {
  key: string;
  type: SearchFieldType;
  operators: SearchOperator[];
  sortable: boolean;
  enumValues: string[] | null;
}

export interface SearchDatasetDto {
  key: string;
  fields: SearchFieldDto[];
}

export interface SearchCatalogResponse {
  schemaVersion: number;
  datasets: SearchDatasetDto[];
}

/** value ist ein JSON-Wert (string | number | boolean | Array); IsEmpty/IsNotEmpty ohne value. */
export interface SearchFilterRule {
  field: string;
  operator: SearchOperator;
  value?: unknown;
}

export interface SearchFilterGroup {
  logic: SearchGroupLogic;
  rules: SearchFilterRule[];
  groups: SearchFilterGroup[];
}

export interface SearchSort {
  field: string;
  descending: boolean;
}

export interface AdvancedSearchRequest {
  dataset: string;
  schemaVersion?: number;
  filters?: SearchFilterGroup | null;
  columns?: string[] | null;
  sort?: SearchSort[] | null;
  page?: number;
  pageSize?: number;
  propertyIds?: string[] | null;
}

export interface AdvancedSearchRow {
  id: string;
  cells: Record<string, unknown>;
}

export interface AdvancedSearchResponse {
  dataset: string;
  schemaVersion: number;
  columns: string[];
  results: PagedResult<AdvancedSearchRow>;
}

export type SearchExportFormat = 'csv' | 'xlsx';

/* Persönliche, verschlüsselte Vorlagen — Spiegel von Modules.Search/Contracts/SavedSearchContracts. */

export interface SavedSearchSummary {
  id: string;
  name: string;
  dataset: string;
  schemaVersion: number;
  isStale: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export interface SavedSearchDetail extends SavedSearchSummary {
  filters: SearchFilterGroup | null;
  columns: string[] | null;
  sort: SearchSort[] | null;
  pageSize: number;
}

export interface SaveSearchRequest {
  name: string;
  dataset: string;
  filters?: SearchFilterGroup | null;
  columns?: string[] | null;
  sort?: SearchSort[] | null;
  pageSize: number;
}

export interface RunSavedSearchRequest {
  page?: number;
  pageSize?: number | null;
  propertyIds?: string[] | null;
}
